import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }

import { computed ,onBeforeMount,onBeforeUnmount, onMounted } from 'vue'
import { useStore } from 'vuex'
import { getSystemTime } from '@/utils/index'
import { getUserInfo, trackStatistic, getUserSoundsSetting, getUserKeyboardKeybinding, getCorpLogoUrl, getTenantList } from '@/service'
import {$enum} from '@/global/index'
import flyReplay from '@/components/modules/flight/flyReplay/index.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

const isShowEngineView = computed(() => {
  return store.state.viewData.isShowEngineView
})

const engineViewPosition = computed(() => {
  return store.state.viewData.engineViewPosition
})

const engineViewStyle = computed(() => {
  const style: any = {
    ...engineViewPosition.value,
  }
  return style
})

const showFlyReplay = computed(() => {
  return store.getters['viewData/showFlyReplay']
})

const flyReplayData = computed(() => {
  return store.getters['viewData/flyReplayData']
})

const closeFlyReplay = () => {
  window?.playClick()
  store.commit('viewData/setShowFlyReplay', false)
}

const loadUserSoundsSetting = async (userId: string | number | null) => {
  store.commit('viewData/setEngineConfigReady', false)
  store.commit('persistence/setUseNewEngineUrl', false)
  store.commit('persistence/setEngineVersion', '')
  try {
    const soundRes = await getUserSoundsSetting({id:userId}) as any
    if(soundRes.code == $enum.EnumResult.SUCCESS){
      const soundData = soundRes.data || {}
      const droneSound = Number.isFinite(Number(soundData.droneSound)) ? Number(soundData.droneSound) : 30
      const humanSound = Number.isFinite(Number(soundData.humanSound)) ? Number(soundData.humanSound) : 30
      const otherSound = Number.isFinite(Number(soundData.otherSound)) ? Number(soundData.otherSound) : 30
      const resolution = typeof soundData.resolution === 'string' ? soundData.resolution : "1920*1080"
      const engineVersion = typeof soundData.engineVersion === 'string' && soundData.engineVersion.trim() !== '' ? soundData.engineVersion.trim().toUpperCase() : ''
      const useNewEngineUrl = engineVersion !== ''
      store.commit('persistence/setEngineVersion', engineVersion)
      store.commit('persistence/setUseNewEngineUrl', useNewEngineUrl)
      store.commit('persistence/setSounds', {droneSound, humanSound, otherSound})
      store.commit('persistence/setResolution', resolution)
    }
  } catch (error) {
    console.error('Failed to get user sounds setting:', error)
  } finally {
    store.commit('viewData/setEngineConfigReady', true)
  }
}

const getUserMessage = async ()=>{
  let res = await getUserInfo();
  if(res.code == $enum.EnumResult.SUCCESS){
    let data = res.data as any || { userId: '', username: '' };
    let user = {
      userId:data.userId,
      userName:data.username,
      name:data.name,
      appId:data.appId,
      phoneNum:data.phoneNum
    }
    store.commit('persistence/setUserInfo',user);
    await loadUserSoundsSetting(user.userId);

    try {
      const tenantListRes = await getTenantList() as any
      if (
        tenantListRes.code == $enum.EnumResult.SUCCESS &&
        Array.isArray(tenantListRes.data) &&
        tenantListRes.data.length > 0
      ) {
        store.commit('persistence/setCurrentTenantId', tenantListRes.data[0].id)
      }
    } catch {
      store.commit('persistence/setCurrentTenantId', null)
    }

    //获取logo图片
    if(data?.cid){
      let logoRes = await getCorpLogoUrl({id:data?.cid}) as any;
      if(logoRes.code == $enum.EnumResult.SUCCESS && logoRes.data){
        store.commit('viewData/setLogoUrl', logoRes.data)
      }else{
        store.commit('viewData/setIsShowLocalLogo', true)
      }
    }else{
      store.commit('viewData/setIsShowLocalLogo', true)
    }
    

    let keyboardRes = await getUserKeyboardKeybinding({id:user.userId}) as any
    if(keyboardRes.code == $enum.EnumResult.SUCCESS && keyboardRes.data && Object.keys(keyboardRes.data).length > 0){
      let {reset,switchGuid,switchView,homing,enlarge,reduce,shoot} = keyboardRes.data || {reset:'',switchGuid:'', switchView:'', homing:'', enlarge:'', reduce:'', shoot:''};
      store.commit('persistence/setKeyboard', {reset,switchGuid,switchView,homing,enlarge,reduce,shoot})
    }
    const eventTime = getSystemTime()
    trackStatistic([{appId:data.appId,userId:data.userId,eventKey:"simulator_open",eventTime}])
  }else{
    store.commit('viewData/setIsShowLocalLogo', true)
    store.commit('persistence/setUseNewEngineUrl', false)
    store.commit('persistence/setEngineVersion', '')
    store.commit('viewData/setEngineConfigReady', true)
  }
}

async function init(){
  const token = localStorage.getItem("Authorization");
  if(token){
    void getUserMessage().catch((error) => {
      console.error('Failed to initialize user settings:', error)
      if (!store.state.viewData.engineConfigReady) {
        store.commit('persistence/setUseNewEngineUrl', false)
        store.commit('persistence/setEngineVersion', '')
        store.commit('viewData/setEngineConfigReady', true)
      }
    });
  }
}

// onMounted(()=>{
//   setTimeout(()=>{
//     init();
//   },0)
// })

onBeforeMount(()=>{
  setTimeout(()=>{
    init();
  },0)
})

onBeforeUnmount(()=>{
  const app = store.state.viewData.pixiInstance as any;
  if(app){
    app.destroy(true);
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_vkm_engineView = _resolveComponent("vkm-engineView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    _withDirectives(_createVNode(_component_vkm_engineView, {
      style: _normalizeStyle(engineViewStyle.value)
    }, null, 8, ["style"]), [
      [_vShow, isShowEngineView.value]
    ]),
    (showFlyReplay.value)
      ? (_openBlock(), _createBlock(flyReplay, {
          key: 0,
          title: flyReplayData.value.title,
          score: flyReplayData.value.score,
          "is-pass": flyReplayData.value.isPass,
          rating: flyReplayData.value.rating,
          "ability-data": flyReplayData.value.abilityData,
          "flight-summary": flyReplayData.value.flightSummary,
          "training-suggestion": flyReplayData.value.trainingSuggestion,
          "wind-direction": flyReplayData.value.windDirection,
          "wind-speed": flyReplayData.value.windSpeed,
          pageMode: flyReplayData.value.pageMode,
          enterMode: flyReplayData.value.enterMode,
          trainingId: flyReplayData.value.trainingId,
          deviationInfo: flyReplayData.value.deviationInfo,
          scenePictureUrl: flyReplayData.value.scenePictureUrl,
          onClose: closeFlyReplay
        }, null, 8, ["title", "score", "is-pass", "rating", "ability-data", "flight-summary", "training-suggestion", "wind-direction", "wind-speed", "pageMode", "enterMode", "trainingId", "deviationInfo", "scenePictureUrl"]))
      : _createCommentVNode("", true)
  ]))
}
}

})